"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        marginRight: 10,
        outline: 'none',
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexFlow: 'row wrap',
        lineHeight: '15px',
        '& button': {
            height: '100%',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            textTransform: 'capitalize'
        },
        '&[data-is-set=true]': {
            '& button': {
                color: theme.grey1,
                textTransform: 'unset'
            }
        }
    },
    multiselectInputDropDown: {
        width: '100%',
        border: `1px solid ${theme.indigo3}`,
        borderRadius: '2px 2px 1px 1px'
    },
    tooltipHeader: {
        cursor: 'pointer',
        padding: 7,
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        height: '100%'
    },
    option: {
        cursor: 'pointer',
        padding: '11px 10px',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
        '&[data-is-selected=true]': {
            backgroundColor: theme.indigoPastel3
        },
        '&:hover': {
            backgroundColor: theme.indigoPastel3
        }
    },
    textDisplay: {
        flexGrow: 1,
        fontSize: 14,
        whiteSpace: 'nowrap',
        color: theme.grey1,
        outline: 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&[data-is-unset=true]': {
            color: theme.grey3
        }
    },
    multiselectDropdownIcon: {
        marginLeft: 5,
        flexShrink: 0,
        height: 17,
        width: 17,
        color: theme.grey4,
        transition: 'transform 0.3s ease-in-out',
        '&[data-input-focused=true]': {
            transform: 'rotate(180deg)',
            color: theme.indigo3
        },
        '& svg': {
            fill: theme.grey1
        }
    },
    optionsList: {
        maxHeight: 160,
        overflow: 'auto',
        position: 'absolute',
        top: 40,
        left: 0,
        zIndex: 3,
        background: theme.white1,
        border: ({ shadows }) => (!shadows ? `1px solid ${theme.indigo3}` : 'none'),
        boxShadow: ({ shadows }) => (shadows ? theme.indigoShadow1 : 'unset'),
        borderRadius: 2,
        width: '100%',
        '&::placeholder': {
            color: theme.grey4
        },
        '&::-webkit-scrollbar': {
            cursor: 'pointer',
            width: 5
        },
        '&::-webkit-scrollbar-track': {
            background: theme.grey8,
            borderRadius: 10
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.grey4,
            borderRadius: 10,
            '&:hover': {
                background: theme.grey3
            }
        }
    }
});
//# sourceMappingURL=multiSelect.style.js.map